(function () {

  function resolveCtn(table) {
    let ctnQty = Number(window.ctnQty);
    let ctnUnit = window.ctnUnit;

    // Quick View: innerHTML 不执行产品页脚本，从挂载点 data-* 读取
    const mount = table && table.closest('.samitaWS_volumeTable_product_form');
    if (mount) {
      const dataQty = Number(mount.getAttribute('data-ctn-qty') || 0);
      const dataUnit = (mount.getAttribute('data-ctn-unit') || '').trim();
      if (dataQty) ctnQty = dataQty;
      if (dataUnit) ctnUnit = dataUnit;
    }

    return { ctnQty, ctnUnit };
  }

  // const ctnQty = Number(window.ctnQty);
  // const ctnUnit = window.ctnUnit;

  // if (!ctnQty || !ctnUnit) return;

  function initTable(table) {

    const { ctnQty, ctnUnit } = resolveCtn(table);
    if (!ctnQty || !ctnUnit) return;

    const headerRow = table.querySelector('thead tr');
    const rows = table.querySelectorAll('tbody tr');

    if (!headerRow || rows.length === 0) return;

    // 只做一次结构插入
    if (!table.dataset.ppuInit) {

      // header
      const th = document.createElement('th');
      th.className = 'ppu-header';
      th.textContent = `Price/${ctnUnit}`;
      headerRow.appendChild(th);

      // rows
      rows.forEach(row => {
        const td = document.createElement('td');
        td.className = 'ppu-cell';
        row.appendChild(td);
      });

      table.dataset.ppuInit = '1';
    }

    // 只更新数值（不动 DOM 结构）
    rows.forEach(row => {

      const priceCell = row.children[1];
      const targetCell = row.querySelector('.ppu-cell');

      if (!priceCell || !targetCell) return;

      const price = parseFloat(
        priceCell.textContent.replace(/[^0-9.]/g, '')
      );

      if (isNaN(price)) return;

      targetCell.textContent =
        '$' + (price / ctnQty).toFixed(2);
    });

    // 一次性显示（避免闪烁）
    requestAnimationFrame(() => {
      table.querySelectorAll('.ppu-header, .ppu-cell')
        .forEach(el => {
          el.style.visibility = 'visible';
        });
    });
  }

  function tick() {

    // const table = document.querySelector(
    //   '.samitaWS_volumeTable_product_form table'
    // );

    // if (table) {
    //   initTable(table);
    // }
    
    const table = document.querySelectorAll(
      '.samitaWS_volumeTable_product_form table'
    );

    if (table && table.length) {
      table.forEach(initTable);
    }

  }

  // document.addEventListener('DOMContentLoaded', () => {

  //   setInterval(() => {
  //     tick();
  //   }, 200);

  // });
  function start() {
    setInterval(() => {
      tick();
    }, 200);
  }
  
  // 在 samita-custom.liquid 里加载此脚本，改成全局 defer 后，经常是「DOM 已完成 → 再执行本文件」，若不判断 readyState，轮询根本不会开始，Price/Roll 也就加不上。
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Quick View 打开后再跑一轮（Samita 异步注入）
  window.addEventListener('themeQuickshopOpened', tick);

})();